import { provide , inject, ref} from 'vue'

const userSelected = Symbol('userSelected')

export function getSelectedData(){    
    
    //搜尋結果 存放的地方
    const selectedLevel = ref("");
    const selectedSubject = ref("");
    const selectedSDG = ref('');
    const selectedArea = ref("");
    const searchKeyWord= ref(""); 


    provide(userSelected,{
        selectedLevel,
        selectedSubject,
        selectedSDG,
        selectedArea,
        searchKeyWord,
   
    })
}

export function useSelectedData(){
    const context = inject(userSelected)
    if(!context){
        throw new Error('not provided yet, not registered')
    }
        
    return context
}
